import React, { useState } from 'react'
import { observer } from 'mobx-react'
import InputColor from './InputColor'
import useSettingsManager from '../hooks/use-settings-manager'
import usePortManager from '../hooks/use-port-manager'
import InputDefault from './InputDefault'

function InputColors (props) {

  const _name = props.name
  const manager = usePortManager()

  const settings_manager = useSettingsManager()
  const _settings = settings_manager.getInputSettings(props.name)

  const label = settings_manager.getOtherSettings('add_custom_ral', 'Tilføj egen RAL')

  const sable_label = _settings.title_sable
  const ral_label = _settings.title_ral

  const colors = _settings.options

  let model = manager.getValue('model')
  if (typeof model === 'undefined') model = 9000

  const hex = require('ral-to-hex')
  const [show_custom_color_field, setShowCustomColorField] = useState(
    false
  )

  const update = function (key, value) {
    manager.updateValue(key, value)
    try {
      hex(value)
    } catch (e) {
      return
    }
    manager.updateValue(props.name, value)
  }

  const items = []
  const _sable = [9004, 7015]
  const sable = []
  Object.keys(colors).map(function (key, index) {
    if (colors[key] === null) return
    if (manager.getValidModelColors(model).indexOf(parseInt(key)) >= 0) {
      if (_sable.indexOf(parseInt(key)) >= 0) {
        sable.push(<InputColor key={key} name={_name} ral={key} value={key} strings={colors[key]}/>)
      } else {
        items.push(<InputColor key={key} name={_name} ral={key} value={key} strings={colors[key]}/>)
      }
    }
  })

  const custom_color_field = show_custom_color_field ? <InputDefault onChange={update} name={'custom_color'}/> : null

  const inputColorGrid = function (colors, headline) {
    const h = typeof headline === 'string' ? <h3>{headline}</h3> : null
    return (
      <>
        {h}
        <div className={'input-color-grid'}>
          {colors.reverse()}
        </div>
      </>
    )
  }

  return (
    <aside className={'input input-colors'} data-size={props.size}>
      {inputColorGrid(items, ral_label)}
      {sable.length > 0 ? inputColorGrid(sable, sable_label) : null}
      {/*<button onClick={() => setShowCustomColorField(!show_custom_color_field)} className={"link-button link-button--icon"}>
                <SVGIcon type={"add"} fill={"#C7C7C7"} className={"link-button__icon"}/>
                {label}
            </button>
            {custom_color_field}*/}
    </aside>
  )
}

export default observer(InputColors)